import { jsx as _jsx } from "react/jsx-runtime";
import { I18nextProvider, initReactI18next, } from '@stepstone-platform/i18n';
import { decodePlatformSite, } from '@stepstone-platform/platform-apis';
import { createI18N, DEFAULT_I18N_NAMESPACE, FALLBACK_LOCALE_KEY, } from '../create-i18n-instance.js';
import { buildMergedPackage } from '@stepstone-platform/kit/compat';
/**
 * TranslationsProvider is a React component designed for server-side rendering (SSR) to provide translations for a specific package.
 * @property {PlatformSite} platformSite - The platform site information
 * @property {string} defaultLocale - The default locale for translations (can be taken in gcs config)
 * @property {object} translationsJSON - The translations in JSON format. Usually it resides in consument package, built from translation folder using \@stepstone-platform/kit
 * @property {ReactNode} children - The child components or elements to be rendered inside TranslationsProvider.
 @returns {JSX.Element} JSX element representing the TranslationsProvider component.
 */
export const TranslationsProvider = ({ platformSite, defaultLocale, translationsJSON, namespaces, fallbackNS, defaultNS, children, }) => {
    const { brand } = decodePlatformSite(platformSite);
    const merged = buildMergedPackage([
        {
            packageName: DEFAULT_I18N_NAMESPACE,
            packageTranslation: translationsJSON,
        },
    ]);
    const resources = {
        ...merged[brand],
        // fallback for missing translations, it matches the /([a-z]+)-([A-Z]+)/ regex we've got in kit
        // it prevents `react-i18next:: i18n.languages were undefined or empty []` error when there is no labels provided or locale file is missing
        // only the keys will be rendered then
        [FALLBACK_LOCALE_KEY]: { [DEFAULT_I18N_NAMESPACE]: {} },
    };
    const i18n = createI18N({ lng: defaultLocale, resources, ns: namespaces, fallbackNS, defaultNS }, [initReactI18next]);
    return _jsx(I18nextProvider, { i18n: i18n, children: children });
};
//# sourceMappingURL=index.js.map